<script>
    import Comprobantes from './comprobantes.svelte'
    export let data={}
    data.comisiones.importeComisionable = data.planpagos.importeComisionable *1.00
    data.comisiones.importeComisionable1 = parseFloat(data.comisiones.importeComisionable1)<1 ? data.planpagos.importeComisionable *1.00 : data.comisiones.importeComisionable1

    function set_importe2(){
        if(data.comisiones.importeComisionable1<1){
            data.comisiones.importeComisionable1 = data.comisiones.importeComisionable
            data.comisiones.importeComisionable2 = 0
            data.comisiones.importeComisionable3 = 0
        }
        if (data.comisiones.importeComisionable>data.comisiones.importeComisionable1) {
            data.comisiones.importeComisionable2 = data.comisiones.importeComisionable-data.comisiones.importeComisionable1
            data.comisiones.importeComisionable3 = data.comisiones.importeComisionable-data.comisiones.importeComisionable1-data.comisiones.importeComisionable2
        }else{
            data.comisiones.importeComisionable1 = data.comisiones.importeComisionable
            data.comisiones.importeComisionable2 = 0
            data.comisiones.importeComisionable3 = 0
        }
    }

    function set_importe3(){
        if(data.comisiones.importeComisionable2>0){
        data.comisiones.importeComisionable3 = data.comisiones.importeComisionable-data.comisiones.importeComisionable1-data.comisiones.importeComisionable2
        }else{
            data.comisiones.importeComisionable1 = data.planpagos.importeComisionable *1.00
            data.comisiones.importeComisionable3 = 0

        }
        if(data.comisiones.importeComisionable3<1){
            data.comisiones.importeComisionable3 = 0
            data.comisiones.importeComisionable2 = data.comisiones.importeComisionable-data.comisiones.importeComisionable1
        }
    }

</script>

<table class="table">
    <thead>
        <tr>
            <th class="text-center">IMPORTE</th>
            <th class="text-center">Importe1</th>
            <th class="text-center">Importe2</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>
                <input class="text-end" value={data.comisiones.importeComisionable.toFixed(2)} readonly tabindex="-1"/>
            </td>
            <td><input class="text-end" bind:value={data.comisiones.importeComisionable1} on:change={set_importe2}/></td>
            <td><input class="text-end" bind:value={data.comisiones.importeComisionable2} on:change={set_importe3} 
                    disabled={data.comisiones.importeComisionable-data.comisiones.importeComisionable1<1}/></td>
        </tr>

        {#if data.planpagos.vendedor!==''}
            <tr>
                <td>{data.planpagos.vendedor}</td>
                <td class="">
                    <input size=3 class="text-end" bind:value={data.comisiones.comiI1v} />
                    {(data.comisiones.importeComisionable1*data.comisiones.comiI1v/100).toFixed(2)}
                </td>
                <td class="">
                    <input size=3 class="text-end" bind:value={data.comisiones.comiI2v} />
                    {(data.comisiones.importeComisionable2*data.comisiones.comiI2v/100).toFixed(2)}
                </td>
               
            </tr>
        {/if}

        {#if data.planpagos.linea1!==''}
            <tr>
                <td>{data.planpagos.linea1}</td>
                <td class="">
                    <input size=3 class="text-end" bind:value={data.comisiones.comiI1L1} />
                    {(data.comisiones.importeComisionable1*data.comisiones.comiI1L1/100).toFixed(2)}
                </td>
                <td class="">
                    <input size=3 class="text-end" bind:value={data.comisiones.comiI2L1} />
                    {(data.comisiones.importeComisionable2*data.comisiones.comiI2L1/100).toFixed(2)}
                </td>
            </tr>
        {/if}

        {#if data.planpagos.linea2}
            <tr>
                <td>{data.planpagos.linea2}</td>
                <td class="">
                    <input size=3 class="text-end" bind:value={data.comisiones.comiI1L2} />
                    {(data.comisiones.importeComisionable1*data.comisiones.comiI1L2/100).toFixed(2)}
                </td>
                <td class="">
                    <input size=3 class="text-end" bind:value={data.comisiones.comiI2L2} />
                    {(data.comisiones.importeComisionable2*data.comisiones.comiI2L2/100).toFixed(2)}
                </td>
            </tr>
        {/if}
        
        {#if data.planpagos.linea3}
            <tr>
                <td>{data.planpagos.linea3}</td>
                <td class="">
                    <input size=3 class="text-end" bind:value={data.comisiones.comiI1L3} />
                    {(data.comisiones.importeComisionable1*data.comisiones.comiI1L3/100).toFixed(2)}
                </td>
                <td class="">
                    <input size=3 class="text-end" bind:value={data.comisiones.comiI2L3} />
                    {(data.comisiones.importeComisionable2*data.comisiones.comiI2L3/100).toFixed(2)}
                </td>
            </tr>
        {/if}
    </tbody>
</table>

<Comprobantes cliente="{data.idcliente}" venta="{data.id}" />
<!--pre>{JSON.stringify(data,null,2)}</pre-->


<style>
    input[readonly      ]{
        background-color: #F5F5F5;
    }
</style>